import $ from 'jquery';
import { gsap } from 'gsap';

import { $Elements, Animations, Events, Classes, Durations } from '../global/constants';
import { debounce, throttle } from 'throttle-debounce';
import { wait } from '../global/helpers';

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Content Sections ----------

	$('.parallax-section:not(fixed):not(.transition-clone)').each(function() {

		Animations.mobile.max.push(() => this.classList.remove(Classes.moving));

		Animations.mobile.min.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector(':scope .section-image');
			const speed = parseInt(this.dataset.speed, 10);

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

				timeline.fromTo(
					image,
					{ y: () => offset() * (speed / 100), ease: 'none' },
					{ y: () => offset() * (-speed / 100), ease: 'none' }
				);
			}
		});
	});

	// ---------- Scrolling Text Section ----------

	$('.scrolling-text-section').each(function() {

		const content = $(this).find('.content');

		if(content.length) {

			const text = content.text().split(' ');
			let splitted = '';

			text.forEach(span => splitted += '<span style="opacity: .1;">' + span + '</span>\n');
			content.html(splitted);

			Animations.global.push(() => {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top top',
						end: '+=200%',
						pin: true,
						scrub: true,
						invalidateOnRefresh: true,
					}
				});

				content.find('span').each((i, span) => timeline.to(span, {
					opacity: 1,
				}));
			});
		}
	});

	// ---------- Images Stack Section ----------

	$('.images-stack-section').each(function() {

		const images = $(this).find('.image-column:not(:first-child)');

		if(images.length) {

			images.each((i, image) => gsap.set(image, { y: '100vh' }));

			Animations.global.push(() => {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top top',
						end: '+=' + (images.length) + '00%',
						pin: true,
						scrub: true,
						invalidateOnRefresh: true,
					}
				});

				images.each((i, image) => timeline.to(image, {
					y: 0,
					rotate: (i % 2) ? '-20deg' : '20deg'
				}));
			});
		}
	});

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 66%',
					toggleClass: Classes.active,
					onEnter: async() => {
						if(this.classList.contains('wine-etiquette-section')) {
							const lottie = this.querySelector('lottie-player');

							if(lottie) {
								await wait(Durations.animations.ms);
								lottie.play();
							}
						}
					}
				}
			});
		});
	});

	// ---------- Animated Section ----------

	$('.product-scroll-section').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: document.querySelector('.product-header-section'),
					start: 'bottom top',
					end: () => $Elements.PageWrapper.height(),
					toggleClass: {
						targets: this,
						className: Classes.active,
					},
				}
			});
		});
	});

	// ---------- Menu ----------

	$Elements.HeaderWrapper.each(function() {

		Animations.global.push(() => {

			gsap.timeline({
				scrollTrigger: {
					start: 10,
					end: () => $Elements.PageWrapper.height(),
					onUpdate: throttle(200, false, (self) => {
						(self.direction === -1) ? this.classList.remove(Classes.shrink) : this.classList.add(Classes.shrink);
						(self.progress > 0) ? this.classList.add(Classes.shrinkable) : this.classList.remove(Classes.shrinkable);
					})
				}
			});
		});
	});
};

$Elements.document.on(Events.page.enter, () => initScrollAnimations());
